module.exports = __webpack_public_path__ + "img/km_23.e082dfa0.jpeg";